<template>

  <my-carousel
    :per-page-custom="[
      [0, 1],
      [768, 2],
      [991, 2],
      [1100, 3],
      [1440, 4],
    ]"
    :pagination-enabled="true"
    :scroll-per-page="true"
    :navigation-enabled="true"
    :navigation-next-label="'<span></span>'"
    :navigation-prev-label="'<span></span>'"
    ref="home_news"
  >
    <slide v-for="(item, key) in news" :key="key">
      <div class="carousel-card d-flex flex-column">
        <div class="badges">
            <div v-if="item.luogo" class="badge eventos">Eventos</div>
            <div v-else class="badge noticias">Noticias</div>
            <img v-if="item.immagine" :src="item.immagine" class="img-responsive">
            <img v-else :src="`${config.cdn_img + item.immagine_cdn}`" class="img-responsive">
        </div>
       
        <div class="content">
          <h4>{{ item.titolo }}</h4>
          <div v-if="item.luogo">
            <p class="location">{{ item.luogo }}</p>
            <div class="info-event" >
              <div class="date" v-if="item.customDate"><img src="/images/site/icons/calendar.svg" class="event-icon">{{ item.customDate }}</div>
              <div class="time"  v-if="item.customTime"> <img src="/images/site/icons/clock.svg" class="event-icon"> {{ item.customTime }}</div>
            </div>
          </div>
          <div class="description" v-html="item.descrizione"></div>

          <div class="mt-2 mb-1 mx-auto">
            <a :href="`/noticias/${item.id}`" class="btn btn-small btn-blue">Saber más</a>
          </div>
        </div>
      </div>
    </slide>
  </my-carousel>
</template>

<script>
import MyCarousel from "./MyCarousel";

export default {
  components: {
    "my-carousel": MyCarousel,
  },

  props: {
    news: Array,
    config: Object,
  },

  computed: {
    lang() {
      return "es"; // this.$root.lang.home
    },
  },

  methods: {
    isValidURL(url) {
      let urlRegex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/\S*)?$/i;

      return urlRegex.test(url);
    },
  },
};
</script>
